// extracted by mini-css-extract-plugin
module.exports = {"AnswersItem":"AnswersItem_AnswersItem__1RCCx","success":"AnswersItem_success__1o3ZQ","error":"AnswersItem_error__1ixfm"};